import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

/**
 * Adjunta `Authorization: Bearer <token>` a cada request hacia nuestro API.
 * Skip de endpoints públicos (login, health) y de URLs externas.
 *
 * Detecta el "API propio" comparando contra `environment.apiUrl` — cubre
 * los 3 modos (prod / local:8000 / dev:api-dev) sin hardcodear URLs.
 */
export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  // No tocar requests cross-origin a otros servicios (Google Fonts, etc.)
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }

  // Skip endpoints públicos.
  //
  // `/publico/` es importante: son rutas anónimas (convocatoria, candidatos,
  // contacto inmobiliario). Si un visitante tiene una sesión vieja del CRM en el
  // mismo navegador y le adjuntáramos ese token, un 401 haría que
  // `authErrorInterceptor` lo expulse a /login desde una página pública.
  if (
    req.url.includes('/auth/login') ||
    req.url.includes('/publico/') ||
    req.url.endsWith('/health')
  ) {
    return next(req);
  }

  const token = inject(AuthService).getToken();
  if (!token) return next(req);

  return next(
    req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    }),
  );
};
